import { render, staticRenderFns } from "./ImageHistoryUpdateModal.vue?vue&type=template&id=2832ad0a&scoped=true&"
import script from "./ImageHistoryUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ImageHistoryUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageHistoryUpdateModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImageHistoryUpdateModal.vue?vue&type=style&index=1&id=2832ad0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832ad0a",
  null
  
)

export default component.exports